import { combineReducers } from "redux";

import { isLoaderReducer } from "./isLoaderReducer/isLoaderReducer";
import { userReducer } from "./userReducer/userReducer";
import { metaReducer } from "./metaReducer/metaReducer";
import { socketReducer } from "./socketReducer/socketReducer";

export const reducers = combineReducers({
  isLoader: isLoaderReducer,
  user: userReducer,
  meta: metaReducer,
  socket: socketReducer,
});
